var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('Snackbar'),(_vm.displayNavbar)?_c('Navbar'):_vm._e(),(_vm.displayNavDrawer)?_c('NavDrawer'):_vm._e(),_c('v-content',[_c('router-view',{key:_vm.$route.path})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }